import { inject } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { finalize } from 'rxjs';
import { LoadingService } from '../services/loading.service';
import { environment } from '../../../environments/environment';

export const LoadingInterceptor: HttpInterceptorFn = (req, next) => {
  const loadingService = inject(LoadingService);

  const apiBaseUrl = environment.apiUrl;
  const isApiCall = req.url.startsWith(apiBaseUrl);

  const skip = req.headers.has('X-Skip-Loading') || !isApiCall;

  if (!skip) {
    loadingService.show();
  }

  return next(req).pipe(
    finalize(() => {
      if (!skip) {
        loadingService.hide();
      }
    })
  );
};
